// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 5px;
  padding: 5px;
  display: block;
}

ion-radio {
  --color: var(--randy-gray);
  --color-checked: var(--randy-red);
  --border-color: #CCCCCC;
  --border-width: 2px;
}
ion-radio.radio-checked {
  --color: var(--randy-red);
  --border-color: var(--randy-red);
}
ion-radio.radio-checked::part(mark) {
  transform: scale3d(1.1, 1.1, 1);
}
ion-radio.radio-checked::part(container) {
  border-color: var(--randy-red);
}

.price {
  font-family: AppFont;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.78px;
  letter-spacing: 0.01em;
  text-align: right;
  margin-inline-start: 4px;
  text-align: end;
  color: var(--color-black);
}

ion-label {
  display: block;
  font-family: AppFont !important;
  font-size: 14px !important;
  line-height: 17.78px;
  letter-spacing: 0.01em;
  text-align: left;
  color: var(--color-black) !important;
}

.measurement {
  font-size: 12px;
}

ion-icon {
  color: var(--randy-red-dark);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

ion-item {
  border: 0.6px solid #666666;
  border-left: none;
  border-right: none;
}

.selected {
  font-family: AppFont, sans-serif;
}

.pfand {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-single/article-option-group-single.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACD;;AAEA;EACC,0BAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;AACD;AACC;EACC,yBAAA;EACA,gCAAA;AACF;AACE;EACC,+BAAA;AACH;AAEE;EACC,8BAAA;AAAH;;AAKA;EACC,oBAAA;EACA,eAAA;EACG,gBAAA;EACH,oBAAA;EACA,sBAAA;EACA,iBAAA;EAGA,wBAAA;EACA,eAAA;EACA,yBAAA;AAJD;;AAOA;EACC,cAAA;EACA,+BAAA;EACA,0BAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AAJD;;AAMA;EACC,eAAA;AAHD;;AAKA;EACC,4BAAA;EACA,YAAA;EACA,WAAA;AAFD;;AAKA;EACC,qBAAA;AAFD;;AAIA;EACE,2BAAA;EACA,iBAAA;EACA,kBAAA;AADF;;AAGA;EACC,gCAAA;AAAD;;AAGA;EACC,eAAA;AAAD","sourcesContent":["ion-radio-group {\n\twidth: 100%;\n\tborder-radius: 5px;\n\tpadding: 5px;\n\tdisplay: block;\n}\n\nion-radio {\n\t--color: var(--randy-gray);\n\t--color-checked: var(--randy-red);\n\t--border-color: #CCCCCC;\n\t--border-width: 2px;\n\n\t&.radio-checked {\n\t\t--color: var(--randy-red);\n\t\t--border-color: var(--randy-red);\n\t\t\n\t\t&::part(mark) {\n\t\t\ttransform: scale3d(1.1, 1.1, 1);\n\t\t}\n\t\t\n\t\t&::part(container) {\n\t\t\tborder-color: var(--randy-red);\n\t\t}\n\t}\n}\n\n.price {\n\tfont-family: AppFont;\n\tfont-size: 14px;\n    font-weight: 400;\n\tline-height: 17.78px;\n\tletter-spacing: 0.01em;\n\ttext-align: right;\n\n\t\n\tmargin-inline-start: 4px;\n\ttext-align: end;\n\tcolor: var(--color-black);\n}\n\nion-label {\n\tdisplay: block;\n\tfont-family: AppFont !important;\n\tfont-size: 14px !important;\n\tline-height: 17.78px;\n\tletter-spacing: 0.01em;\n\ttext-align: left;\n\tcolor: var(--color-black) !important;\n}\n.measurement {\n\tfont-size: 12px;\n}\nion-icon {\n\tcolor: var(--randy-red-dark);\n\theight: 20px;\n\twidth: 20px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\nion-item {\n  border: 0.6px solid #666666;\n  border-left: none;\n  border-right: none;\n}\n.selected {\n\tfont-family: AppFont, sans-serif;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
